export default __webpack_public_path__ + "static/logo_says-899d2d11730d0d7fe955c968b07e5b01.png";